import { render } from "./GiftCodeDialog.vue?vue&type=template&id=dff76094&scoped=true"
import script from "./GiftCodeDialog.vue?vue&type=script&lang=js"
export * from "./GiftCodeDialog.vue?vue&type=script&lang=js"

import "./GiftCodeDialog.vue?vue&type=style&index=0&id=dff76094&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff76094"]])

export default __exports__